import { inject } from '@angular/core';
import { CanMatchFn } from '@angular/router';
import { AppConfigService } from '../services/app-config.service';

// canMatch (not canActivate): falls through to the Access Denied route below, with no
// login attempt, for every environment except local dev.
export const localOnlyMatchGuard: CanMatchFn = () => {
  const appConfigService = inject(AppConfigService);
  return appConfigService.config.environment === 'local';
};
